import {
    /** FETCH APPLICATION  */
    FETCH_STARTAPPLICATIONV2_FULFILLED,
    FETCH_STARTAPPLICATIONV2_REJECTED,
    FETCH_STARTAPPLICATIONV2_PENDING,
    RESET_STARTAPPLICATIONV2
} from "../../actions/v3/startApplication";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_STARTAPPLICATIONV2_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_STARTAPPLICATIONV2_FULFILLED:
            return {
                ...state,
                startApplicationv2: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_STARTAPPLICATIONV2_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_STARTAPPLICATIONV2:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};